"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.firstInputDelay = void 0;
var _attribution = require("web-vitals/attribution");
var _vitalMetric = require("./vital-metric");
var _constants = require("./constants");
var _runtime = require("../constants/runtime");
const firstInputDelay = exports.firstInputDelay = new _vitalMetric.VitalMetric(_constants.VITAL_NAMES.FIRST_INPUT_DELAY);
if (_runtime.isBrowserScope) {
  (0, _attribution.onFID)(({
    value,
    attribution
  }) => {
    if (_runtime.initiallyHidden || firstInputDelay.isValid) return;
    const attrs = {
      type: attribution.eventType,
      fid: Math.round(value),
      eventTarget: attribution.eventTarget,
      loadState: attribution.loadState
    };

    // CWV will only report one (THE) first-input entry to us; fid isn't reported if there are no user interactions occurs before the *first* page hiding.
    firstInputDelay.update({
      value: attribution.eventTime,
      attrs
    });
  });
}